import { render, staticRenderFns } from "./TransferTab64.vue?vue&type=template&id=3052fd26"
import script from "./TransferTab64.vue?vue&type=script&lang=js"
export * from "./TransferTab64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports